import { useEffect } from 'react'

import { UseLoggedContext } from '@mercadoni/sinister/dist/cjs/authentication'

import { DeadpoolUser } from '~types/index'

interface UseLoggedStateProps {
  customer: DeadpoolUser | null
  isInitialized: boolean
}

/**
 * Custom hook for managing logged state
 * Updates the global logged state based on customer authentication
 */
export const useLoggedState = ({
  customer,
  isInitialized,
}: UseLoggedStateProps) => {
  const context = UseLoggedContext()
  const { setIsLogged } = context || {}

  useEffect(() => {
    if (isInitialized && customer?.id && setIsLogged) {
      try {
        setIsLogged(true)
      } catch (error) {
        // Handle errors gracefully
        console.error('Error setting logged state:', error)
      }
    }
  }, [customer?.id, isInitialized, setIsLogged])
}
